import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import MainApp from '../src/components/MainApp';
import './assets/styles/app.scss';
import './assets/styles/index.css';
// Initialize date utilities (dayjs plugins and locale)
import '@/common/utils/date';
// Initialize PDF.js worker
import './utils/pdfWorkerConfig';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tunnel: `${import.meta.env.VITE_API_BASE_URL}/sentry-tunnel`,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
  release: import.meta.env.VITE_APP_RELEASE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: false,
  tracePropagationTargets: [import.meta.env.VITE_API_BASE_URL].filter(Boolean),
  beforeSend(event) {
    const sensitiveKeys = ['dni', 'cuit', 'password', 'token', 'password_confirmation'];
    if (event.request?.data && typeof event.request.data === 'object') {
      sensitiveKeys.forEach((key) => {
        if (key in event.request.data) event.request.data[key] = '[Filtered]';
      });
    }
    return event;
  },
});

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<MainApp />);
